import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import HideIf from "util/HideIf";
import { capitalize } from "util/lodash/capitalize";
import PAText, { FONT_SIZE } from "../typography/PAText/PAText";
import styles from "./textTooltip.module.scss";

const ICON_MAP = {
  SUMMER: "summer-color.png",
  WINTER: "winter-color.png",
  ALL: "all-season-color.png",
  "ALL SEASON": "all-season-color.png",
  ÉTÉ: "summer-color.png",
  HIVER: "winter-color.png",
  "TOUTE SAISON": "all-season-color.png",
};

// todo, show image with css before
function TireSeasonIcon(props: any) {
  const {
    season, style, iconOnly, row = false, width = 28, height = 28, showIcon = true, color, fontSize,
  } = props;
  const { t } = useTranslation("category");

  if (!season) {
    return null;
  }
  if (iconOnly) {
    return (
      <Image
        className="pointer"
        src={`${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/${ICON_MAP[season]}`}
        alt={season}
        unoptimized
        width={width}
        height={height}
      />
    );
  }
  const flexClass = row ? "flex-row" : "flex-column";
  const className = `${flexClass}`;
  return (
    <div className={`${className} d-flex ${styles.img_container}`} style={style}>

      <HideIf show={showIcon}>
        <div>
          <Image
            className="pointer"
            src={`${process.env.NEXT_PUBLIC_ROOT_URL}/cms/pubicImages/images/${ICON_MAP[season]}`}
            alt={season}
            unoptimized
            width={width}
            height={height}
          />
        </div>
      </HideIf>

      <PAText component="span" className={styles.text} color={color || "success-secondary"} fontSize={fontSize || FONT_SIZE[1]}>{t(capitalize(season))}</PAText>
    </div>
  );
}

export default TireSeasonIcon;
